'use client';

import { SharpeValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  values: SharpeValues;
  onValuesChange: (field: keyof SharpeValues, value: number) => void;
  translations: ToolsTranslations['sharpeRatio'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const handleChange = (field: keyof SharpeValues) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\s/g, '').replace(/,/g, '.');
    const value = Number(raw);
    onValuesChange(field, isNaN(value) ? 0 : value);
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.expectedReturnPercent}</label>
        <input type="text" value={values.expectedReturnPercent} onChange={handleChange('expectedReturnPercent')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.riskFreeRatePercent}</label>
        <input type="text" value={values.riskFreeRatePercent} onChange={handleChange('riskFreeRatePercent')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.stdDeviationPercent}</label>
        <input type="text" value={values.stdDeviationPercent} onChange={handleChange('stdDeviationPercent')} className={inputClass} placeholder="0" />
      </div>
    </div>
  );
}


